<template>
	<div>
		<home @home_height="getHeight" @inHome="markHome" />
		<!-- Navigation area Start -->
		<section id="navigation" :class="{ 'nav-wrap': isScroll }">
			<div class="container-fluid">
				<div class="row">
					<div class="col-6 text-center">
						<a
							class="logo logo-text"
							tag="[object Object]"
							data-scroll
							href="#Home"
							><span style="font-weight: 700; padding: 0 10px"> &lt;</span
							><span class="logo-name px-2"> Hamid</span><span>/&gt;</span></a
						>
						<!--            <div class="logo text-xl-center text-right text-sm-right">-->
						<!--              <a data-scroll href="#body" class="logo-text" />-->
						<!--            </div>-->
					</div>
					<div class="col-4">
						<div
							class="mid-nav d-flex justify-content-center justify-content-sm-end"
						>
							<div class="resu">
								<a
									href="https://www.dropbox.com/scl/fi/dn54iuer0r1orm8fw2665/Shamsiar-Hamid_CV_2022.docx?dl=0&rlkey=bl4v4warw1ehbryni48emk74a"
									target="_blank"
									>Resume</a
								>
							</div>
						</div>
					</div>
					<div class="col-2">
						<nav>
							<div
								:class="{ 'burger--active': isClicked }"
								class="burger"
								@click="toggleMenu()"
							>
								<!-- Add class for change burger symbol -->
								<div class="burger__patty" />
							</div>
							<ul class="nav__list" :class="{ 'nav__list--active': isClicked }">
								<li title="Home" class="nav__item">
									<a
										href="#header"
										:class="{ nav__link__active: isHome }"
										class="nav__link c-blue"
									>
										<!-- Add class for see which  page  is open -->
										<img src="images/menu_img/home-icon.png" alt />
										<span class="tooltiptext">Home</span>
									</a>
								</li>
								<li title="About" class="nav__item">
									<a
										href="#about"
										:class="{ nav__link__active: isAbout }"
										class="nav__link c-yellow scrolly"
									>
										<!-- Add class for see which  page  is open -->
										<img src="images/menu_img/about-icon.png" alt />
										<span class="tooltiptext">About</span>
									</a>
								</li>
								<li title="Experience" class="nav__item">
									<a
										href="#experience"
										:class="{ nav__link__active: isExperience }"
										class="nav__link c-red"
									>
										<!-- Add class for see which  page  is open -->
										<img src="images/menu_img/exp.png" alt />
										<span class="tooltiptext">Experience</span>
									</a>
								</li>
								<li title="Projects" class="nav__item">
									<a
										href="#portfolio"
										:class="{ nav__link__active: isProject }"
										class="nav__link c-green"
									>
										<!-- Add class for see which  page  is open -->
										<img src="images/menu_img/projects-icon.png" alt />
										<span class="tooltiptext">Projects</span>
									</a>
								</li>
								<li title="Skills" class="nav__item">
									<a
										href="#skill"
										:class="{ nav__link__active: isSkill }"
										class="nav__link c-green"
									>
										<!-- Add class for see which  page  is open -->
										<img src="images/menu_img/skill.png" alt />
										<span class="tooltiptext">Skills</span>
									</a>
								</li>
								<!--                                <li title="Testimonial" class="nav__item">-->
								<!--                                    <a href="#testimonial" :class="{ nav__link__active: isTestimonial }" class="nav__link c-green">-->
								<!--                                        &lt;!&ndash; Add class for see which  page  is open &ndash;&gt;-->
								<!--                                        <img src="images/menu_img/testi.png" alt />-->
								<!--                                        <span class="tooltiptext">Testimonial</span>-->
								<!--                                    </a>-->
								<!--                                </li>-->
								<li title="Contact" class="nav__item">
									<a
										href="#contact"
										:class="{ nav__link__active: isContact }"
										class="nav__link c-green"
									>
										<!-- Add class for see which  page  is open -->
										<img src="images/menu_img/contact-icon.png" alt />
										<span class="tooltiptext">Contact</span>
									</a>
								</li>
							</ul>
						</nav>
					</div>
				</div>
			</div>
		</section>
		<!-- Navigation area End -->
		<about @inAbout="markAbout" />
		<experience @inExperience="markExperience" />
		<portfolio @inProject="markProject" />
		<skills @inSkill="markSkill" />
		<contact @inContact="markContact" />

		<scroll-up custom-class="scrollUp" :scroll-duration="100" :scroll-y="250" />
	</div>
</template>

<script>
import ScrollUp from "vue-scroll-up";
import "vue-scroll-up/dist/style.css";
import About from "./components/About.vue";
// import Testimonial from "./components/xxTestimonial.vue";
import Contact from "./components/Contact.vue";
import Experience from "./components/Experience.vue";
import Home from "./components/Home.vue";
import Portfolio from "./components/Portfolio.vue";
import Skills from "./components/Skills.vue";
// import DropdownMenu from "@innologica/vue-dropdown-menu";

export default {
	components: {
		About,
		Contact,
		// Testimonial,
		Skills,
		Portfolio,
		Experience,
		Home,
		ScrollUp,
		// DropdownMenu,
	},
	data() {
		return {
			isClicked: false,
			isScroll: false,
			home_height: "",
			isHome: true,
			isAbout: false,
			isExperience: false,
			isProject: false,
			isSkill: false,
			isContact: false,
		};
	},
	mounted() {
		window.addEventListener("scroll", this.ifScroll);
	},
	methods: {
		toggleMenu() {
			this.isClicked = !this.isClicked;
		},
		getHeight(value) {
			this.home_height = value;
		},
		ifScroll() {
			var scrollPosition = window.pageYOffset;
			if (scrollPosition >= this.home_height / 1.25) {
				this.isScroll = true;
			} else {
				this.isScroll = false;
			}
		},
		mark_nothing() {
			this.isHome = false;
			this.isAbout = false;
			this.isExperience = false;
			this.isSkill = false;
			this.isProject = false;
			this.isContact = false;
		},
		markHome() {
			this.mark_nothing();
			this.isHome = true;
		},
		markAbout() {
			this.mark_nothing();
			this.isAbout = true;
		},
		markExperience() {
			this.mark_nothing();
			this.isExperience = true;
		},
		markProject() {
			this.mark_nothing();
			this.isProject = true;
		},
		markSkill() {
			this.mark_nothing();
			this.isSkill = true;
		},
		markContact() {
			this.mark_nothing();
			this.isContact = true;
		},
	},
};
</script>

<style scoped></style>
